import {Alert, Form, Modal, Select} from 'antd';
import React from 'react';

import {useAdminUpdatePalletOrderAttachmentMetadataMutation} from '../../../../gen/api/apis';
import {AdminPalletOrderAttachmentMetadata, AdminPalletOrderAttachmentType} from '../../../../gen/api/models';
import {useNotification} from '../../../../NotificationContext';
import {palletOrderAttachmentType} from '../../../helpers/labels';

export interface AttachmentProps {
    id: number;
    metadata: AdminPalletOrderAttachmentMetadata;
    onSuccess: () => void;
    onClosed: () => void;
}

interface Values {
    type: AdminPalletOrderAttachmentType;
}

export const EditAttachment = (props: AttachmentProps) => {
    const notify = useNotification();
    const [form] = Form.useForm<Values>();
    const fileType = Form.useWatch('type', form);

    React.useEffect(() => {
        console.log(props.metadata);
        form.setFieldsValue({
            type: props.metadata.type,
        });
    }, [props.metadata]);

    const updateAttachmentRequest = useAdminUpdatePalletOrderAttachmentMetadataMutation({
        onSuccess: () => {
            notify.openNotificationWithIcon('success', 'Attachment updated');
            props.onSuccess();
        },
        onError: (error) => {
            console.error(error);
            notify.openNotificationWithIcon('error', 'Error updating attachment');
        },
    });

    const update = (values: Values) => {
        console.log(values);
        updateAttachmentRequest.mutate({
            id: props.id,
            params: {
                type: values.type,
            },
        });
    };

    return (
        <Modal
            open
            title="Edit Attachment"
            onCancel={props.onClosed}
            confirmLoading={updateAttachmentRequest.isLoading}
            okText="Update"
            okButtonProps={{autoFocus: true, htmlType: 'submit'}}
            cancelText="Cancel"
            maskClosable={false}
            centered
            destroyOnClose
            modalRender={(dom) => (
                <Form
                    layout="horizontal"
                    labelCol={{span: 6}}
                    wrapperCol={{span: 18}}
                    form={form}
                    name="newOrder"
                    clearOnDestroy
                    onFinish={(values) => update(values)}
                >
                    {dom}
                </Form>
            )}
        >
            <Form.Item
                name="type"
                label="File Type"
                style={{marginTop: 16}}
            >
                <Select
                    showSearch
                    placeholder="Select file type"
                    options={palletOrderAttachmentType.map((type) => ({
                        label: type.label,
                        value: type.key,
                    }))}
                />
            </Form.Item>
            {fileType && fileType === AdminPalletOrderAttachmentType.PalletOrderAttachmentTypeAmazonManifest && (
                <Alert
                    message="The file extention must be .csv"
                    description="File must have the following columns: Qty, Item Title, Item Price, and ASIN."
                    type="warning"
                />
            )}
        </Modal>
    );
};
